import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "experience-platform-sdks-vs-4x-sdks"
    }}>{`Experience Platform SDKs vs. 4x SDKs`}</h1>
    <p>{`The following tables provide information about the differences between the new Experience Platform SDKs and the 4x SDKs.`}</p>
    <h2 {...{
      "id": "functionality-support"
    }}>{`Functionality support`}</h2>
    <h3 {...{
      "id": "core-functionality"
    }}>{`Core functionality`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Functionality`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version 4 SDKs`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDKs`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Modular SDK, Adobe and third-party extensions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Server-side configuration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Programmatic configuration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Bundled configuration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Configuration management in tags`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Lifecycle metrics`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes. See `}<a parentName="td" {...{
              "href": "lifecycle.md"
            }}>{`Manual Lifecycle Implementation`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Experience Cloud ID service`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Privacy and GDPR framework`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "adobe-analytics"
    }}>{`Adobe Analytics`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Functionality`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Version 4 SDKs`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDKs`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`App screens & user actions tracking`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Offline tracking`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Hit batching`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Milestone media tracking`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Timed action tracking`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Video heartbeats`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Lifetime value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes. Use Profile extension`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Server-side forwarding - Audience Manager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Set/get custom visitor ID (vid or s.vid)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "adobe-analytics---mobile-services--mobile-add-on"
    }}>{`Adobe Analytics - Mobile Services / Mobile Add-on`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Functionality`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDK`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDK`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Postbacks - Get/POST URL requests`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes - `}<a parentName="td" {...{
              "href": "../../home/base/mobile-core/signal/index.md"
            }}>{`Signals`}</a>{` extension`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Postbacks - PII Get/POST URL requests`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes - `}<a parentName="td" {...{
              "href": "../../home/base/mobile-core/signal/index.md"
            }}>{`Signals`}</a>{` extension`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Postbacks - Open app deeplink`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes - `}<a parentName="td" {...{
              "href": "../../home/base/mobile-core/signal/index.md"
            }}>{`Signals`}</a>{` extension`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Push Messaging`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes - `}<a parentName="td" {...{
              "href": "https://developer.adobe.com/client-sdks/edge/adobe-journey-optimizer/"
            }}>{`Adobe Journey Optimizer`}</a>{` extension`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`In-app Messaging`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes - `}<a parentName="td" {...{
              "href": "https://developer.adobe.com/client-sdks/edge/adobe-journey-optimizer/"
            }}>{`Adobe Journey Optimizer`}</a>{` extension`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Marketing/Acquisition Links`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Not supported`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Geo location and beacon tracking`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes - `}<a parentName="td" {...{
              "href": "../../solution/places/index.md"
            }}>{`Places extension`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Geo points-of-interest management`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes - `}<a parentName="td" {...{
              "href": "../../solution/places/index.md"
            }}>{`Places extension`}</a></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "adobe-audience-manager"
    }}>{`Adobe Audience Manager`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Functionality`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDKs`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDKs`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Send signals to Audience Manager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Reset identifiers and profiles`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Return visitor profiles`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`DPID/DPUUID synching`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
      </tbody>
    </table>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Although synching with integration codes is fully supported, the Experience Cloud SDKs do not offer synch support with integration codes. The use of DPID/DPUUID are not supported.`}</p>
    <h3 {...{
      "id": "adobe-target"
    }}>{`Adobe Target`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Functionality`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDKs`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDKs`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`A/B, Multivariate Testing, Offers`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Offer pre-fetch`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Offer preview`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "osplatform-support"
    }}>{`OS/platform support`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Functionality`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`4x SDKs`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Experience Platform SDKs`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Android`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Android Wear​`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Support coming`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Apple iOS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Apple WatchOS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Support coming`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Apple tvOS`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`React Native (iOS & Android)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Flutter (iOS & Android)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Unsupported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Unity (iOS & Android)​`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Xamarin (iOS & Android)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Cordova (iOS & Android)​`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Universal Windows Platform (UWP) / Win 10`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Unsupported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Not supported`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Windows 8​`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Not supported`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Blackberry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Supported`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`Not supported`}</em></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      